import type { ReactNode } from 'react';

export const symbol_bookmark_flag: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M435-430v-95h145q8.5 0 12.75-8t-.75-16l-38-51 38-51q5-8 .75-16T580-675H415q-12.75 0-21.37 8.62Q385-657.75 385-645v215q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08 7-7.09 7-17.92Zm45 190-196 84q-30 13-57-4.76-27-17.75-27-50.24v-574q0-24 18-42t42-18h440q24 0 42 18t18 42v574q0 32.49-27 50.24Q706-143 676-156l-196-84Zm0-64 220 93v-574H260v574l220-93Zm0-481H260h440-220Z"
		/>
	</svg>
);
